define('views/modules/calendar/animated-session/tags/manager/edit/placeholder/tag-exercise-placeholder',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/modules/calendar/animated-session/tags/edit/placeholder/tag-exercise-placeholder.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TTagExercisePlaceholder
) {

    var VTagExercisePlaceholder = Backbone.View.extend({
        template: TTagExercisePlaceholder,
        events: {
            'click': 'onClick',
        },

        initialize: function(opt) {
            this.options = opt || {};
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            return this;
        },

        ////////////
        // events //
        ////////////
        onClick: function(e) {
            this.model.trigger('list:addExercise');
        }

    });

    return VTagExercisePlaceholder;

});

